import {createContext, useState} from 'react';

const defaultContextValue = {
  setCanvas: () => null,
  canvas: null,
};

export const EventCreateStampContext = createContext(defaultContextValue);

export const EventCreateStampParent = ({children}) => {
  const [canvas, setCanvas] = useState();

  return (
    <EventCreateStampContext.Provider
      value={{
        canvas,
        setCanvas,
      }}
    >
      {children}
    </EventCreateStampContext.Provider>
  );
};
